import React, { useState } from "react";
import api from "./api";
import "./Login.css";

const Login = ({ onSwitchToRegister }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post("/login.php", { email, password });
            setMessage(res.data.message || res.data.error);
        } catch (err) {
            setMessage("Błąd logowania");
        }
    };

    return (
        <div className="login-page">
            <div className="login-box">
                <h2>Panel klienta</h2>
                <p className="subtitle">Logowanie do systemu</p>

                <form onSubmit={handleLogin}>
                    <input
                        type="email"
                        placeholder="Adres e-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />

                    <input
                        type="password"
                        placeholder="Hasło"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    <button type="submit">Zaloguj się</button>
                </form>

                {message && <p className="message">{message}</p>}

                <p className="register-link">
                    Nie masz konta?{" "}
                    <span onClick={onSwitchToRegister}>Zarejestruj się</span>
                </p>
            </div>
        </div>
    );
};

export default Login;